
// import CatalogPage from '@/components/primary/CatalogPage.vue';
import { mapGetters } from 'vuex';
import SeoMixin from '~/mixins/SeoMixin';

export default {
    name: 'index',
    mixins: [SeoMixin],
    components: {
        CatalogPage: () => import('@/components/primary/CatalogPage.vue'),
        PageBuilder: () => import('@/components/primary/PageBuilder')
    },
    data() {
        return {
            seo: {
                title: '',
                description: '',
                img: '',
                keywords: ''
            }
        };
    },
    layout({ store }) {
        const content = store.getters['builder/getContent'];
        const isFarmacie = store.getters['global/getIsFarmacie'];

        return content?.layout ? 'empty' : isFarmacie ? 'farmacie' : 'default';
    },
    computed: {
        ...mapGetters({
            isFarmacie: 'global/getIsFarmacie',
            globalSettings: 'global/globalSettings'
        }),
        slug() {
            return this.$route.params.pathMatch;
        },
        isPageBuilderRoute() {
            const routes = this.globalSettings.page_builder_routes || [];

            if (routes?.includes(this.slug)) {
                return true;
            } else return false;
        }
    }
    // async asyncData(context) {
    //     let seo = {
    //         title: '',
    //         description: '',
    //         img: ''
    //     };
    //
    //     try {
    //         let seoData = await context.$axios.$get(
    //             `/general/seo/article?category_slug=${context.route.params.pathMatch || context.route.params.slug}`
    //         );
    //         if (seoData) {
    //             seo.title = seoData.title;
    //             seo.description = seoData.description;
    //             seo.img = seoData.img;
    //         }
    //     } catch (error) {
    //         console.error('Failed to fetch SEO:', error);
    //     }
    //
    //     return { seo };
    // }
};
